import { useEffect, useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { Navigator as ReactRouterNavigator } from "react-router";

interface BlockerTx {
    retry: () => void;
}

export function useBlocker(blocker: (tx: BlockerTx) => void, when = true) {
    const { navigator } = useContext(UNSAFE_NavigationContext) as { navigator: ReactRouterNavigator };

    useEffect(() => {
        if (!when) return;

        const push = navigator.push;

        navigator.push = (...args: Parameters<typeof push>) => {
            const tx: BlockerTx = { retry() { push(...args); } };
            blocker(tx);
        };

        return () => {
            navigator.push = push;
        };
    }, [navigator, blocker, when]);
}

export function usePrompt(message: string, when = true) {
    const blocker = (tx: BlockerTx) => {
        if (window.confirm(message)) {
            tx.retry();
        }
    };
    useBlocker(blocker, when);
}
